export default __webpack_public_path__ + "static/media/pura-fe.06262598.webp";